import type * as THREE from 'three';
import type {RevolveFeaturePrototype} from '../../../feature/prototype/revolve/RevolveFeaturePrototype';
import {FeatureResultObject} from '../FeatureResultObject';

/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/mesh/feature/revolve 目录；
 * 2. 负责承载旋转特征正式结果体对象；
 * 3. 结果体直接保留 revolve prototype 作为特征真相引用。
 */

/**
 * 旋转结果体对象。
 */
export class BossRevolveResultObject extends FeatureResultObject<RevolveFeaturePrototype> {
    /**
     * @param input 输入参数。
     */
    public constructor(input: {
        prototype: RevolveFeaturePrototype;
        meshData: MeshData;
        geometry: THREE.BufferGeometry;
        material: THREE.Material | THREE.Material[];
    }) {
        super(input);
    }
}
